import React from 'react';
import { Card } from './ui/card';

const TechnologyCard = ({ category, icon: Icon, color, technologies }) => {
  return (
    <Card className="bg-white p-6 rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-0 overflow-hidden group">
      {/* Category Header */}
      <div className="flex items-center gap-3 mb-4">
        <div className={`w-12 h-12 bg-gradient-to-br ${color} rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
          <Icon className="w-6 h-6 text-white" />
        </div>
        <h3 className="text-lg font-bold text-gray-900">
          {category}
        </h3>
      </div>

      {/* Technologies List */}
      <div className="space-y-2">
        {technologies.map((tech) => (
          <div
            key={tech}
            className="flex items-center gap-2 text-sm text-gray-700 hover:text-cyan-600 transition-colors"
          >
            <div className="w-1.5 h-1.5 bg-cyan-600 rounded-full flex-shrink-0"></div>
            <span>{tech}</span>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default TechnologyCard;
